export const PanelSkeleton = () =>
{
	return <div className="wrapper">
		<div className="animate-pulse flex space-x-4">
			<div className="flex-1">
				<div className="flex justify-between align-center">
					<div className="h-3 bg-disabled rounded w-1/6 mt-2"></div>
					<div className="flex">
						<div className="bg-disabled rounded w-28 h-7 mx-1"></div>
						<div className="bg-disabled rounded w-28 h-7 mx-1"></div>
					</div>
				</div>
				<hr className='border-disabled mb-4'/>
				<div className="flex align-center !mb-12 !last:mb-0">
					<div className="w-1/2">
						<div className="bg-disabled rounded w-40 h-2 mx-1"></div>
						<div className="bg-disabled rounded w-80 h-3 mx-1 mt-3"></div>
					</div>
					<div className="w-1/2">
						<div className="bg-disabled rounded w-40 h-2 mx-1"></div>
						<div className="bg-disabled rounded w-80 h-3 mx-1 mt-3"></div>
					</div>
				</div>
				<div className="flex align-center !mb-12 !last:mb-0">
					<div className="w-1/2">
						<div className="bg-disabled rounded w-40 h-2 mx-1"></div>
						<div className="bg-disabled rounded w-80 h-3 mx-1 mt-3"></div>
					</div>
					<div className="w-1/2">
						<div className="bg-disabled rounded w-40 h-2 mx-1"></div>
						<div className="bg-disabled rounded w-80 h-3 mx-1 mt-3"></div>
					</div>
				</div>
				<div className="flex align-center !mb-12 !last:mb-0">
					<div className="w-1/2">
						<div className="bg-disabled rounded w-40 h-2 mx-1"></div>
						<div className="bg-disabled rounded w-80 h-3 mx-1 mt-3"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
};


export const SubpanelSkeleton = () =>
{
	return <div className="wrapper">
		<div className="animate-pulse flex space-x-4">
			<div className="flex-1 pb-4">
				<div className="flex justify-between align-center">
					<div className="h-2 bg-disabled rounded w-1/6 mt-2"></div>
					<div className="h-2 bg-disabled rounded w-7 h-7 mx-1"></div>
				</div>
				<hr className='border-disabled'/>
				<div className="h-8 bg-disabled rounded"></div>
				<div className="h-3 my-4 bg-disabled rounded"></div>
				<div className="h-3 my-4 bg-disabled rounded"></div>
				<div className="h-3 bg-disabled rounded"></div>
			</div>
		</div>
	</div>
}

export const DashletSkeleton = () => {
	return <div className="animate-pulse flex space-x-4">
		<div className="rounded-full bg-disabled h-12 w-12 me-5"></div>
		<div className="flex-1 space-y-6 pt-2 pb-4">
			<div className="h-2 bg-disabled rounded"></div>
			<div className="space-y-3">
				<div className="grid grid-cols-3 gap-4">
					<div className="h-2 bg-disabled rounded col-span-2"></div>
					<div className="h-2 bg-disabled rounded col-span-1"></div>
				</div>
				<div className="h-2 bg-disabled rounded"></div>
			</div>
		</div>
	</div>
}

export const BarChartSkeleton = () => {
	return <div className="animate-pulse flex space-x-4">
		<div className="flex gap-4 pt-2 pb-4 w-full items-end">
			<div className="w-10 h-32 bg-disabled rounded grow"></div>
			<div className="w-10 h-56 bg-disabled rounded grow"></div>
			<div className="w-10 h-28 bg-disabled rounded grow"></div>
			<div className="w-10 h-40 bg-disabled rounded grow"></div>
			<div className="w-10 h-20 bg-disabled rounded grow"></div>
			<div className="w-10 h-36 bg-disabled rounded grow"></div>
		</div>
	</div>
}